var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvertColours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.594v-14.484l-4.219 4.219q-1.781 1.781-1.781 4.266 0 2.438 1.781 4.219t4.219 1.781zM17.672 7.922q2.344 2.344 2.344 5.648t-2.344 5.648-5.672 2.344q-1.359 0-3.023-0.68t-2.648-1.664q-2.344-2.344-2.344-5.648t2.344-5.648l5.672-5.672z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertColours);
export default __webpack_public_path__ + "static/media/invert-colours.534f8d3e908e81282f0ab346fd21a094.svg";
export { ForwardRef as ReactComponent };